import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { addMessage } from 'researcher/application/actions';
import { getProviders } from 'researcher/application/reducer';
import { getReferringUrl, getInitialFormData } from '../reducer';
import Register from './Register';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    user = _ref.user,
    account = _ref.account;
  var match = _ref2.match,
    location = _ref2.location;
  return {
    initialFormData: getInitialFormData({
      account: account,
      match: match
    }),
    localAuthEnabled: application.config.localAuthEnabled,
    match: match,
    referringUrl: getReferringUrl({
      location: location
    }),
    providers: getProviders({
      application: application
    }),
    user: user
  };
};
var mapDispatchToProps = {
  addMessage: addMessage
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));